import { denormalize } from "normalizr";
import schemas from "utils/schemas";

export const getFinancedOffers = state => {
  const projection = state.currentFolder.financedOffers;
  if (projection && projection.isLoaded) {
    const financedOffers = denormalize(projection.ids, [schemas.financedOffer], state.entities);
    return financedOffers;
  }
  return [];
};

export const getOfferPartners = state => {
  const projection = state.currentFolder.offerPartners;
  if (projection.isLoaded) {
    const offerPartners = denormalize(projection.ids, [schemas.offerPartner], state.entities);
    return offerPartners;
  }
  return [];
};

export const getClientOffers = state => {
  const projection = state.currentFolder.clientOffers;
  if (projection && projection.isLoaded) {
    const clientOffers = denormalize(projection.ids, [schemas.clientOffer], state.entities);
    return clientOffers;
  }
  return [];
};
